import React from "react";
import { cx } from "utils/join-classnames";
import styles from "./Page.module.scss";

type Theme = "dark" | "light";

const pageThemes: { [k: string]: Theme } = {
    dark: "dark",
    light: "light",
};

interface Props {
    className?: string;
    theme?: Theme;
    padding: boolean;
    centered: boolean;
    children: React.ReactNode;
}

const Page: React.FC<Props> = ({
    className = null,
    padding = false,
    centered = false,
    theme = pageThemes.light,
    children,
}) => {
    const wrapperClasses = cx(
        styles.wrapper,
        className,
        theme === pageThemes.dark ? styles.is__dark : null,
        padding ? styles.has__padding : null,
        centered ? styles.is__centered : null,
    );
    return <div className={wrapperClasses}>{children}</div>;
};
export default Page;
